(function () {
  var C = window.HB_GIFT;
  if (!C || !C.gift || window.__hbGift) return;
  window.__hbGift = true;
  var LAMPS = (C.lamps || []).map(String);
  var GIFT = String(C.gift);
  var MAX = typeof C.max === 'number' ? C.max : 9999;
  var of = window.fetch.bind(window);

  function urlOf(input) {
    return typeof input === 'string' ? input : input && input.url ? input.url : String(input || '');
  }
  function isOp(u, op) {
    return new RegExp('/cart/' + op + '(\\.js)?(\\?|$)').test(u);
  }
  function getCart() {
    return of('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }
  function counts(cart) {
    var s = { L: 0, G: 0, gk: null, items: cart.items || [] };
    s.items.forEach(function (i) {
      var v = String(i.variant_id);
      if (LAMPS.indexOf(v) > -1) s.L += i.quantity;
      if (v === GIFT) {
        s.G += i.quantity;
        if (!s.gk) s.gk = i.key;
      }
    });
    return s;
  }
  function post(path, data) {
    return of(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).catch(function () {});
  }
  function setGift(target, s) {
    target = Math.max(0, Math.min(target, MAX));
    if (target === s.G) return Promise.resolve(false);
    var u = {};
    if (s.gk) {
      s.items.forEach(function (i) {
        if (String(i.variant_id) === GIFT) u[i.key] = 0;
      });
      u[s.gk] = target;
      return post('/cart/update.js', { updates: u }).then(function () {
        return true;
      });
    }
    if (target > 0) return post('/cart/add.js', { items: [{ id: Number(GIFT), quantity: target }] }).then(function () {
      return true;
    });
    return Promise.resolve(false);
  }
  function sync() {
    return getCart().then(function (cart) {
      var s = counts(cart);
      return setGift(s.L, s);
    });
  }
  function readBody(body) {
    var o = {};
    if (!body) return { o: o, kind: 'none' };
    if (typeof body === 'string') {
      try {
        return { o: JSON.parse(body), kind: 'json' };
      } catch (e) {
        new URLSearchParams(body).forEach(function (v, k) {
          o[k] = v;
        });
        return { o: o, kind: 'form' };
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.forEach(function (v, k) {
        o[k] = v;
      });
      return { o: o, kind: 'formdata' };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.forEach(function (v, k) {
        o[k] = v;
      });
      return { o: o, kind: 'form' };
    }
    return { o: o, kind: 'other' };
  }
  function addedLamps(o) {
    var n = 0;
    if (Array.isArray(o.items)) {
      o.items.forEach(function (i) {
        if (LAMPS.indexOf(String(i.id)) > -1) n += Number(i.quantity || 1);
      });
      return n;
    }
    var idx = {};
    Object.keys(o).forEach(function (k) {
      var m = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (m) {
        idx[m[1]] = idx[m[1]] || {};
        idx[m[1]][m[2]] = o[k];
      }
    });
    Object.keys(idx).forEach(function (k) {
      if (LAMPS.indexOf(String(idx[k].id)) > -1) n += Number(idx[k].quantity || 1);
    });
    if (o.id && LAMPS.indexOf(String(o.id)) > -1) n += Number(o.quantity || 1);
    return n;
  }
  function withBody(init, data) {
    var h = new Headers((init && init.headers) || {});
    h.set('Content-Type', 'application/json');
    if (!h.has('Accept')) h.set('Accept', 'application/json');
    return Object.assign({}, init, { body: JSON.stringify(data), headers: h });
  }

  window.fetch = function (input, init) {
    var u = urlOf(input);
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST' || u.indexOf('/cart/') === -1 || (init && init.__hb)) return of(input, init);

    if (isOp(u, 'add')) {
      var add = readBody(init && init.body);
      var n = addedLamps(add.o);
      if (!n) return of(input, init);
      return getCart()
        .then(function (cart) {
          var s = counts(cart);
          return setGift(s.L + n, s);
        })
        .catch(function () {})
        .then(function () {
          return of(input, init);
        })
        .then(function (res) {
          if (!res.ok) sync();
          return res;
        });
    }

    if (isOp(u, 'change')) {
      var ch = readBody(init && init.body);
      if (ch.kind === 'none' || ch.kind === 'other') return of(input, init);
      var o = ch.o;
      return getCart()
        .then(function (cart) {
          var s = counts(cart);
          var line = null;
          if (o.line) line = s.items[Number(o.line) - 1];
          else if (o.id) {
            line = s.items.filter(function (i) {
              return i.key === String(o.id) || String(i.variant_id) === String(o.id);
            })[0];
          }
          if (!line) return init;
          var q = Number(o.quantity);
          var data = Object.assign({}, o);
          delete data.line;
          data.id = line.key;
          if (String(line.variant_id) === GIFT) {
            data.quantity = Math.min(s.L, MAX);
            return withBody(init, data);
          }
          if (LAMPS.indexOf(String(line.variant_id)) > -1 && !isNaN(q)) {
            return setGift(s.L - line.quantity + q, s).then(function () {
              return withBody(init, data);
            });
          }
          return withBody(init, data);
        })
        .catch(function () {
          return init;
        })
        .then(function (i2) {
          return of(input, i2);
        });
    }

    if (isOp(u, 'update')) {
      return of(input, init).then(function (res) {
        if (res.ok) sync();
        return res;
      });
    }
    return of(input, init);
  };

  function boot() {
    sync()
      .then(function (changed) {
        var k = 'hb-gift-reload';
        if (!changed) {
          try {
            sessionStorage.removeItem(k);
          } catch (e) {}
          return;
        }
        var cartPage = /\/cart\/?$/.test(location.pathname);
        if (cartPage) {
          try {
            if (sessionStorage.getItem(k)) return;
            sessionStorage.setItem(k, '1');
          } catch (e) {}
          location.reload();
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var f = e.target, b = e.submitter;
    if (!f || !b || b.name !== 'checkout' || f.__hbOk) return;
    e.preventDefault();
    sync().catch(function () {}).then(function () { location.href = '/checkout'; });
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
    if (!a) return;
    e.preventDefault();
    sync().catch(function () {}).then(function () { location.href = a.href; });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
